import { useState } from "react";
import { useNotification } from "../../toster-notification/NotificationContext";
import Loader from "../../shared/Loader";
import { CloseGreyIcon } from "../../../assets/icons";
import { PlanSubscriptionDeactivationReasonType } from "../../../models/base/PlanSubscriptionDeactivationReasonType";
import { planSubscriptionService } from "../../../services/planSubscriptionService";


interface CancelSubscriptionViewProps {
    onClose: () => void;
    id: string;
}

const CancelSubscriptionView: React.FC<CancelSubscriptionViewProps> = ({ onClose, id }) => {

    const [selectedReason, setSelectedReason] = useState<PlanSubscriptionDeactivationReasonType>(PlanSubscriptionDeactivationReasonType.None);
    const [errorSelectReason, setErrorSelectReason] = useState<string>("");
    const [note, setNote] = useState<string>("");
    const [errorNote, setErrorNote] = useState<string>("");

    const reasonKeys = Object.keys(PlanSubscriptionDeactivationReasonType)
        .filter(k => isNaN(Number(k))) as Array<keyof typeof PlanSubscriptionDeactivationReasonType>;

    const [loading, setLoading] = useState<boolean>(false);

    const { notify } = useNotification();


    const handleCancelSubscription = async () => {

        setErrorNote("");
        setErrorSelectReason("");

        let valid = true;

        if (!selectedReason) {
            setErrorSelectReason("Izaberite razlog otkazivanja");
            valid = false;
        }

        if (!note) {
            setErrorNote("Unesite napomenu");
            valid = false;
        }

        if (!valid) {
            return;
        }

        setLoading(true);
        try {
            const response = await planSubscriptionService.cancel(id, {
                deactivationReason: note,
                deactivationReasonType: selectedReason
            });

            if (response.success) {
                notify("success", "Uspešno otkazivanje plana lokala",);
                onClose();
            } else {
                notify("error", "Došlo je do greške prilikom otkazivanja plana lokala");
            }
        } catch (error: any) {
            notify("error", "Došlo je do greške prilikom otkazivanja plana lokala");
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Loader />
    }

    return (
        <section className="modal-section plan-func">
            <div className="w-layout-blockcontainer container w-container">
                <div className="modal-wrapper">
                    <div className="modal-div">
                        <div className="modal-header-div">
                            <div>
                                <div className="modal-header">
                                    <strong>Otkži plan lokala</strong>
                                </div>
                                <div className="description-text">Otkaži prevremeno plan za lokal</div>
                            </div>
                            <div className="modal-button-div">
                                <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" />
                            </div>
                        </div>
                        <div className="modal-form-block w-form">
                            <form className="modal-form">

                                <div className="modal-form-div">
                                    <label className="modal-form-label">Izaberi razlog otkazivanje</label>
                                    <select
                                        className="form-select auto-width w-select"
                                        value={selectedReason}
                                        onChange={(e) =>
                                            setSelectedReason(Number(e.target.value) as PlanSubscriptionDeactivationReasonType)
                                        }
                                    >
                                        <option value={PlanSubscriptionDeactivationReasonType.None}>Izaberi razlog</option>

                                        {reasonKeys
                                            .filter(k => k !== "None")
                                            .map((key) => {
                                                const value = PlanSubscriptionDeactivationReasonType[key]; // broj
                                                return (
                                                    <option key={key} value={value}>
                                                        {key}
                                                    </option>
                                                );
                                            })}
                                    </select>
                                    <div className="error-text margin-top--5px">{errorSelectReason}</div>
                                </div>

                                <div className="modal-form-div">
                                    <label className="modal-form-label">Unesi napomenu razloga prevremenog otkazivanja</label>
                                    <textarea placeholder="" className="form-textarea grey w-input"
                                        value={note}
                                        onChange={(e) => setNote(e.target.value)}
                                    ></textarea>
                                    <div className="error-text margin-top--5px">{errorNote}</div>
                                </div>

                            </form>
                        </div>
                        <div className="modal-buttons">
                            <div className="button-secondary medium" onClick={onClose}>
                                <div>Otkaži</div>
                            </div>
                            <div className="button-primary medium" onClick={() => handleCancelSubscription()}>
                                <div>Potvrdi</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
};

export default CancelSubscriptionView;